export default "__VITE_ASSET__DoB2x67$__"